/* tslint:disable */
/* eslint-disable */
/**
 * WESMASH2 ANAGRAFICA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AnswerRequestModel
 */
export interface AnswerRequestModel {
    /**
     * Identificativo domanda a cui si sta rispondendo
     * @type {number}
     * @memberof AnswerRequestModel
     */
    'questionId': number;
    /**
     * Le risposte alla domanda.
     * @type {Array<string>}
     * @memberof AnswerRequestModel
     */
    'answers': Array<string>;
}
/**
 * 
 * @export
 * @interface AuthResponseDto
 */
export interface AuthResponseDto {
    /**
     * ID Token for authentication
     * @type {string}
     * @memberof AuthResponseDto
     */
    'idToken': string;
    /**
     * Access Token for API requests
     * @type {string}
     * @memberof AuthResponseDto
     */
    'accessToken': string;
    /**
     * Refresh Token for obtaining new tokens
     * @type {string}
     * @memberof AuthResponseDto
     */
    'refreshToken': string;
    /**
     * Token expiration time in seconds
     * @type {number}
     * @memberof AuthResponseDto
     */
    'expiresIn': number;
    /**
     * Type of token (e.g., Bearer)
     * @type {string}
     * @memberof AuthResponseDto
     */
    'tokenType': string;
}
/**
 * 
 * @export
 * @interface BadResponseDto
 */
export interface BadResponseDto {
    /**
     * Response status code
     * @type {number}
     * @memberof BadResponseDto
     */
    'statusCode': number;
    /**
     * Custom message if any
     * @type {object}
     * @memberof BadResponseDto
     */
    'message': object;
    /**
     * error code if present
     * @type {string}
     * @memberof BadResponseDto
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface BookingPaymentRequest
 */
export interface BookingPaymentRequest {
    /**
     * ID Utente in formato UUID
     * @type {string}
     * @memberof BookingPaymentRequest
     */
    'userId': string;
    /**
     * ID Booking in formato UUID
     * @type {string}
     * @memberof BookingPaymentRequest
     */
    'bookingId': string;
    /**
     * Quota con cui lo SLAVE contribuisce al pagamento MASTER.<br>       Obbligatorio solo per pagamenti di tipo SLAVE.<br>       Il campo è ignorato se type è MASTER
     * @type {number}
     * @memberof BookingPaymentRequest
     */
    'quota': number;
    /**
     * Tipo di pagamento.<br>       MASTER: responsabile del pagamento per il booking.<br>       SLAVE: partecipante che contribuisce con una quota al pagamento MASTER
     * @type {string}
     * @memberof BookingPaymentRequest
     */
    'type': BookingPaymentRequestTypeEnum;
}

export const BookingPaymentRequestTypeEnum = {
    Master: 'MASTER',
    Slave: 'SLAVE'
} as const;

export type BookingPaymentRequestTypeEnum = typeof BookingPaymentRequestTypeEnum[keyof typeof BookingPaymentRequestTypeEnum];

/**
 * 
 * @export
 * @interface Canbooking201Response
 */
export interface Canbooking201Response {
    /**
     * 
     * @type {string}
     * @memberof Canbooking201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface CreateMembershipDto
 */
export interface CreateMembershipDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'clubId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'status': CreateMembershipDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'activationDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'renewalDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'expirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMembershipDto
     */
    'paymentMethod': CreateMembershipDtoPaymentMethodEnum;
    /**
     * possibile solo se paymentMethod === CARD
     * @type {boolean}
     * @memberof CreateMembershipDto
     */
    'autoRenewal': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateMembershipDto
     */
    'price': number;
}

export const CreateMembershipDtoStatusEnum = {
    Active: 'active',
    Suspended: 'suspended',
    PendingPayment: 'pending_payment',
    Cancelled: 'cancelled'
} as const;

export type CreateMembershipDtoStatusEnum = typeof CreateMembershipDtoStatusEnum[keyof typeof CreateMembershipDtoStatusEnum];
export const CreateMembershipDtoPaymentMethodEnum = {
    Card: 'CARD',
    Cash: 'CASH'
} as const;

export type CreateMembershipDtoPaymentMethodEnum = typeof CreateMembershipDtoPaymentMethodEnum[keyof typeof CreateMembershipDtoPaymentMethodEnum];

/**
 * 
 * @export
 * @interface GenericResponseDto
 */
export interface GenericResponseDto {
    /**
     * Response status code
     * @type {number}
     * @memberof GenericResponseDto
     */
    'statusCode': number;
    /**
     * Custom message if any
     * @type {object}
     * @memberof GenericResponseDto
     */
    'message': object;
}
/**
 * 
 * @export
 * @interface GetCurrentUserInformation200Response
 */
export interface GetCurrentUserInformation200Response {
    /**
     * 
     * @type {User}
     * @memberof GetCurrentUserInformation200Response
     */
    'user'?: User;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof GetCurrentUserInformation200Response
     */
    'memberships'?: Array<Membership>;
}
/**
 * 
 * @export
 * @interface GetProfilePictureResponse
 */
export interface GetProfilePictureResponse {
    /**
     * Collegamento all\'immagine con validità 10 minuti
     * @type {string}
     * @memberof GetProfilePictureResponse
     */
    'pictureLink': string;
}
/**
 * 
 * @export
 * @interface GetStatus200Response
 */
export interface GetStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetStatus200Response
     */
    'annullabile'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStatus200Response
     */
    'splitPaymentPossibile'?: boolean;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'clubName': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userNome': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userCognome': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'clubId': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    'welcomeKitDelivered': boolean;
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'paymentMethod': string;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    'autoRenewal': boolean;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'activationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'renewalDate': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface MembershipPaymentRequest
 */
export interface MembershipPaymentRequest {
    /**
     * ID Membership in formato UUID
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'membershipId': string;
    /**
     * ID utente UUID
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'userId': string;
    /**
     * ID club per cui si acquista UUID
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'clubId': string;
    /**
     * Quota richiesta in fase di pagamento
     * @type {number}
     * @memberof MembershipPaymentRequest
     */
    'quota': number;
    /**
     * Data programmata per l\'avvio delle transazioni
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'dueDate': string;
    /**
     * Data programmata per l\'attivazione della membership
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'start_at': string;
    /**
     * Data creazione ticket pagamento
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'createdAt': string;
    /**
     * Stato attuale del pagamento
     * @type {string}
     * @memberof MembershipPaymentRequest
     */
    'status': MembershipPaymentRequestStatusEnum;
}

export const MembershipPaymentRequestStatusEnum = {
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type MembershipPaymentRequestStatusEnum = typeof MembershipPaymentRequestStatusEnum[keyof typeof MembershipPaymentRequestStatusEnum];

/**
 * 
 * @export
 * @interface PaymentCallbackDto
 */
export interface PaymentCallbackDto {
    /**
     * ID of the payment
     * @type {string}
     * @memberof PaymentCallbackDto
     */
    'paymentId': string;
    /**
     * Status of the payment
     * @type {boolean}
     * @memberof PaymentCallbackDto
     */
    'isSuccess': boolean;
}
/**
 * 
 * @export
 * @interface PurchaseMembershipDto
 */
export interface PurchaseMembershipDto {
    /**
     * 
     * @type {string}
     * @memberof PurchaseMembershipDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseMembershipDto
     */
    'clubId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseMembershipDto
     */
    'paymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseMembershipDto
     */
    'autoRenewal': string;
}
/**
 * 
 * @export
 * @interface RecurringPaymentRequest
 */
export interface RecurringPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RecurringPaymentRequest
     */
    'paymentId': string;
}
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface RegistrationInfo
 */
export interface RegistrationInfo {
    /**
     * Se l\'utente è registrato oppure no
     * @type {boolean}
     * @memberof RegistrationInfo
     */
    'registered': boolean;
    /**
     * Se l\'utente è stato registrato tramite un provider social oppure no
     * @type {boolean}
     * @memberof RegistrationInfo
     */
    'socialProvided': boolean;
    /**
     * Verifiche in sospeso per l\'utente
     * @type {Array<string>}
     * @memberof RegistrationInfo
     */
    'pendingVerifications': Array<RegistrationInfoPendingVerificationsEnum>;
}

export const RegistrationInfoPendingVerificationsEnum = {
    Email: 'email',
    Cell: 'cell',
    Survey: 'survey',
    Profile: 'profile'
} as const;

export type RegistrationInfoPendingVerificationsEnum = typeof RegistrationInfoPendingVerificationsEnum[keyof typeof RegistrationInfoPendingVerificationsEnum];

/**
 * 
 * @export
 * @interface ResendSignupValidateEmailCodeRequest
 */
export interface ResendSignupValidateEmailCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendSignupValidateEmailCodeRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordConfirmRequest
 */
export interface ResetPasswordConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordConfirmRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordConfirmRequest
     */
    'confirmationCode': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordConfirmRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface SaveCardRequest
 */
export interface SaveCardRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveCardRequest
     */
    'codiceTransazione': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCardRequest
     */
    'xpayNonce': string;
}
/**
 * 
 * @export
 * @interface Settings
 */
export interface Settings {
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'id_settings': string;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'limit_cancel': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'limit_pay': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'max_days_reservation_app': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'max_days_reservation_membership': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'payment_membership_waiting': number;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'android_url': string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'ios_url': string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'min_required_build': string;
    /**
     * 
     * @type {string}
     * @memberof Settings
     */
    'min_required_version': string;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'max_booking_without_membership': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'max_booking_with_membership': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'max_booking_for_user': number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'images_aspect_ratio'?: number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'images_min_horizontal_resolution'?: number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'logo_aspect_ratio'?: number;
    /**
     * 
     * @type {number}
     * @memberof Settings
     */
    'logo_min_horizontal_resolution'?: number;
}
/**
 * 
 * @export
 * @interface SignupDto
 */
export interface SignupDto {
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'nome': string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'cognome': string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'gender'?: SignupDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'citta'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'cell'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'dataDiNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    'profilazioneGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    'marketingGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    'marketingTerzeParti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    'terminiCondizioni'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof SignupDto
     */
    'clubInfo'?: object;
}

export const SignupDtoGenderEnum = {
    Maschio: 'Maschio',
    Femmina: 'Femmina',
    PreferiscoNonRispondere: 'Preferisco non rispondere\"'
} as const;

export type SignupDtoGenderEnum = typeof SignupDtoGenderEnum[keyof typeof SignupDtoGenderEnum];

/**
 * 
 * @export
 * @interface SignupValidateEmailRequest
 */
export interface SignupValidateEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupValidateEmailRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof SignupValidateEmailRequest
     */
    'confirmationCode': string;
}
/**
 * 
 * @export
 * @interface SurveyAnswersRequestModel
 */
export interface SurveyAnswersRequestModel {
    /**
     * Lista di risposte al survey.
     * @type {Array<AnswerRequestModel>}
     * @memberof SurveyAnswersRequestModel
     */
    'answers': Array<AnswerRequestModel>;
}
/**
 * 
 * @export
 * @interface UpdateMembershipDto
 */
export interface UpdateMembershipDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'status'?: UpdateMembershipDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'activationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'renewalDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMembershipDto
     */
    'paymentMethod'?: UpdateMembershipDtoPaymentMethodEnum;
    /**
     * possibile solo se paymentMethod === CARD
     * @type {boolean}
     * @memberof UpdateMembershipDto
     */
    'autoRenewal'?: boolean;
    /**
     * consegnato o meno il welkome kit
     * @type {boolean}
     * @memberof UpdateMembershipDto
     */
    'welcomeKitDelivered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateMembershipDto
     */
    'price'?: number;
}

export const UpdateMembershipDtoStatusEnum = {
    Active: 'active',
    Suspended: 'suspended',
    PendingPayment: 'pending_payment',
    Cancelled: 'cancelled'
} as const;

export type UpdateMembershipDtoStatusEnum = typeof UpdateMembershipDtoStatusEnum[keyof typeof UpdateMembershipDtoStatusEnum];
export const UpdateMembershipDtoPaymentMethodEnum = {
    Card: 'CARD',
    Cash: 'CASH'
} as const;

export type UpdateMembershipDtoPaymentMethodEnum = typeof UpdateMembershipDtoPaymentMethodEnum[keyof typeof UpdateMembershipDtoPaymentMethodEnum];

/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'dataDiNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'citta'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'situazioneSentimentale'?: UpdateUserDtoSituazioneSentimentaleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'statusProfessionale'?: UpdateUserDtoStatusProfessionaleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'profilazioneGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'marketingGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'marketingTerzeParti'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'terminiCondizioni'?: boolean;
}

export const UpdateUserDtoSituazioneSentimentaleEnum = {
    Single: 'Single',
    InUnaRelazione: 'In una relazione',
    SposatoA: 'Sposato/a',
    Altro: 'Altro'
} as const;

export type UpdateUserDtoSituazioneSentimentaleEnum = typeof UpdateUserDtoSituazioneSentimentaleEnum[keyof typeof UpdateUserDtoSituazioneSentimentaleEnum];
export const UpdateUserDtoStatusProfessionaleEnum = {
    Direttore: 'Direttore',
    Executive: 'Executive',
    Imprenditore: 'Imprenditore',
    Manager: 'Manager',
    ImpiegatoA: 'Impiegato/a',
    LiberoProfessionista: 'Libero professionista',
    PensionatoA: 'Pensionato/a',
    Studente: 'Studente',
    Altro: 'Altro'
} as const;

export type UpdateUserDtoStatusProfessionaleEnum = typeof UpdateUserDtoStatusProfessionaleEnum[keyof typeof UpdateUserDtoStatusProfessionaleEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * Version of the user schema, v1 for imported users and v2 for users created on the new app
     * @type {string}
     * @memberof User
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'oldUserId': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': UserStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': UserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'socialProvided': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'nome': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cognome': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cell'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'cellVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender'?: UserGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'dataDiNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'citta'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'situazioneSentimentale'?: UserSituazioneSentimentaleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'statusProfessionale'?: UserStatusProfessionaleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'urlFoto'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'profilazioneGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingTerzeParti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'terminiCondizioni': boolean;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'lastSurveyVersion'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'favorites'?: Array<string>;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof User
     */
    'memberships'?: Array<Membership>;
}

export const UserStatusEnum = {
    EmailConfirmationPending: 'email_confirmation_pending',
    PhoneConfirmationPending: 'phone_confirmation_pending',
    ProfileInformationPending: 'profile_information_pending',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type UserStatusEnum = typeof UserStatusEnum[keyof typeof UserStatusEnum];
export const UserRoleEnum = {
    Admin: 'ADMIN',
    ClubManager: 'CLUB_MANAGER',
    Player: 'PLAYER',
    Teacher: 'TEACHER',
    Assistant: 'ASSISTANT'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];
export const UserGenderEnum = {
    Maschio: 'Maschio',
    Femmina: 'Femmina',
    PreferiscoNonRispondere: 'Preferisco non rispondere\"'
} as const;

export type UserGenderEnum = typeof UserGenderEnum[keyof typeof UserGenderEnum];
export const UserSituazioneSentimentaleEnum = {
    Single: 'Single',
    InUnaRelazione: 'In una relazione',
    SposatoA: 'Sposato/a',
    Altro: 'Altro'
} as const;

export type UserSituazioneSentimentaleEnum = typeof UserSituazioneSentimentaleEnum[keyof typeof UserSituazioneSentimentaleEnum];
export const UserStatusProfessionaleEnum = {
    Direttore: 'Direttore',
    Executive: 'Executive',
    Imprenditore: 'Imprenditore',
    Manager: 'Manager',
    ImpiegatoA: 'Impiegato/a',
    LiberoProfessionista: 'Libero professionista',
    PensionatoA: 'Pensionato/a',
    Studente: 'Studente',
    Altro: 'Altro'
} as const;

export type UserStatusProfessionaleEnum = typeof UserStatusProfessionaleEnum[keyof typeof UserStatusProfessionaleEnum];

/**
 * 
 * @export
 * @interface UserChangePhoneNumberRequest
 */
export interface UserChangePhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChangePhoneNumberRequest
     */
    'phonenumber': string;
}
/**
 * 
 * @export
 * @interface UserChangeProfilePictureRequest
 */
export interface UserChangeProfilePictureRequest {
    /**
     * 
     * @type {UserChangeProfilePictureRequestBody}
     * @memberof UserChangeProfilePictureRequest
     */
    'body': UserChangeProfilePictureRequestBody;
}
/**
 * 
 * @export
 * @interface UserChangeProfilePictureRequestBody
 */
export interface UserChangeProfilePictureRequestBody {
    /**
     * Immagine codificata in base64
     * @type {string}
     * @memberof UserChangeProfilePictureRequestBody
     */
    'picture': string;
}
/**
 * 
 * @export
 * @interface VerifySmsRequest
 */
export interface VerifySmsRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifySmsRequest
     */
    'code': string;
}

/**
 * AnagraficaApi - axios parameter creator
 * @export
 */
export const AnagraficaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Disabilita un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('disableUser', 'userId', userId)
            const localVarPath = `/v2/anagrafica/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni le informazioni dell\'utente corrente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserInformation: async (includeMemberships?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/anagrafica/userinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeMemberships !== undefined) {
                localVarQueryParameter['includeMemberships'] = includeMemberships;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, includeMemberships?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/v2/anagrafica/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeMemberships !== undefined) {
                localVarQueryParameter['includeMemberships'] = includeMemberships;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni un utente per username
         * @param {string} username 
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername: async (username: string, includeMemberships?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserByUsername', 'username', username)
            const localVarPath = `/v2/anagrafica/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (includeMemberships !== undefined) {
                localVarQueryParameter['includeMemberships'] = includeMemberships;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni gli utenti per club ID
         * @param {string} clubId ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getUsers', 'clubId', clubId)
            const localVarPath = `/v2/anagrafica/usersbyclub/{clubId}`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggiorna un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, updateUserDto: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('updateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/v2/anagrafica/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifica il numero di telefono dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangePhoneNumberRequest} userChangePhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangePhoneNumber: async (userId: string, userChangePhoneNumberRequest: UserChangePhoneNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userChangePhoneNumber', 'userId', userId)
            // verify required parameter 'userChangePhoneNumberRequest' is not null or undefined
            assertParamExists('userChangePhoneNumber', 'userChangePhoneNumberRequest', userChangePhoneNumberRequest)
            const localVarPath = `/v2/anagrafica/user/{userId}/phonenumber`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userChangePhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifica l\'immagine profilo dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangeProfilePictureRequest} userChangeProfilePictureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangeProfilePicture: async (userId: string, userChangeProfilePictureRequest: UserChangeProfilePictureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userChangeProfilePicture', 'userId', userId)
            // verify required parameter 'userChangeProfilePictureRequest' is not null or undefined
            assertParamExists('userChangeProfilePicture', 'userChangeProfilePictureRequest', userChangeProfilePictureRequest)
            const localVarPath = `/v2/anagrafica/user/{userId}/profilepicture`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userChangeProfilePictureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetProfilePicture: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userGetProfilePicture', 'userId', userId)
            const localVarPath = `/v2/anagrafica/user/{userId}/profilepicture`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnagraficaApi - functional programming interface
 * @export
 */
export const AnagraficaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnagraficaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Disabilita un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.disableUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni le informazioni dell\'utente corrente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserInformation(includeMemberships?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserInformation(includeMemberships, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.getCurrentUserInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, includeMemberships, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni un utente per username
         * @param {string} username 
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByUsername(username: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByUsername(username, includeMemberships, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.getUserByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni gli utenti per club ID
         * @param {string} clubId ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggiorna un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modifica il numero di telefono dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangePhoneNumberRequest} userChangePhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userChangePhoneNumber(userId: string, userChangePhoneNumberRequest: UserChangePhoneNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userChangePhoneNumber(userId, userChangePhoneNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.userChangePhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Modifica l\'immagine profilo dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangeProfilePictureRequest} userChangeProfilePictureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userChangeProfilePicture(userId: string, userChangeProfilePictureRequest: UserChangeProfilePictureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userChangeProfilePicture(userId, userChangeProfilePictureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.userChangeProfilePicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGetProfilePicture(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfilePictureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGetProfilePicture(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnagraficaApi.userGetProfilePicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnagraficaApi - factory interface
 * @export
 */
export const AnagraficaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnagraficaApiFp(configuration)
    return {
        /**
         * 
         * @summary Disabilita un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disableUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni le informazioni dell\'utente corrente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserInformation(includeMemberships?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserInformation200Response> {
            return localVarFp.getCurrentUserInformation(includeMemberships, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserInformation200Response> {
            return localVarFp.getUserById(userId, includeMemberships, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni un utente per username
         * @param {string} username 
         * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername(username: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentUserInformation200Response> {
            return localVarFp.getUserByUsername(username, includeMemberships, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni gli utenti per club ID
         * @param {string} clubId ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getUsers(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggiorna un utente per ID
         * @param {string} userId ID dell\&#39;utente
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.updateUser(userId, updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifica il numero di telefono dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangePhoneNumberRequest} userChangePhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangePhoneNumber(userId: string, userChangePhoneNumberRequest: UserChangePhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userChangePhoneNumber(userId, userChangePhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifica l\'immagine profilo dell\'utente
         * @param {string} userId ID dell\&#39;utente
         * @param {UserChangeProfilePictureRequest} userChangeProfilePictureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChangeProfilePicture(userId: string, userChangeProfilePictureRequest: UserChangeProfilePictureRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userChangeProfilePicture(userId, userChangeProfilePictureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetProfilePicture(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProfilePictureResponse> {
            return localVarFp.userGetProfilePicture(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnagraficaApi - object-oriented interface
 * @export
 * @class AnagraficaApi
 * @extends {BaseAPI}
 */
export class AnagraficaApi extends BaseAPI {
    /**
     * 
     * @summary Disabilita un utente per ID
     * @param {string} userId ID dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public disableUser(userId: string, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).disableUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni le informazioni dell\'utente corrente
     * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public getCurrentUserInformation(includeMemberships?: boolean, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).getCurrentUserInformation(includeMemberships, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni un utente per ID
     * @param {string} userId ID dell\&#39;utente
     * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public getUserById(userId: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).getUserById(userId, includeMemberships, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni un utente per username
     * @param {string} username 
     * @param {boolean} [includeMemberships] Indica se includere le membership dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public getUserByUsername(username: string, includeMemberships?: boolean, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).getUserByUsername(username, includeMemberships, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni gli utenti per club ID
     * @param {string} clubId ID del club
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public getUsers(clubId: string, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).getUsers(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggiorna un utente per ID
     * @param {string} userId ID dell\&#39;utente
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public updateUser(userId: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).updateUser(userId, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifica il numero di telefono dell\'utente
     * @param {string} userId ID dell\&#39;utente
     * @param {UserChangePhoneNumberRequest} userChangePhoneNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public userChangePhoneNumber(userId: string, userChangePhoneNumberRequest: UserChangePhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).userChangePhoneNumber(userId, userChangePhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifica l\'immagine profilo dell\'utente
     * @param {string} userId ID dell\&#39;utente
     * @param {UserChangeProfilePictureRequest} userChangeProfilePictureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public userChangeProfilePicture(userId: string, userChangeProfilePictureRequest: UserChangeProfilePictureRequest, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).userChangeProfilePicture(userId, userChangeProfilePictureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId ID dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public userGetProfilePicture(userId: string, options?: RawAxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).userGetProfilePicture(userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cambia la password dell\'utente
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/v2/auth/changepassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Effettua il login dell\'utente
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('login', 'loginDto', loginDto)
            const localVarPath = `/v2/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Effettua il login tramite social utilizzando l\'idToken fornito dal social stesso
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSocial: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loginSocial', 'body', body)
            const localVarPath = `/v2/auth/loginsocial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Effettua il logout dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Effettua il refresh dei token identità e accesso mediante il refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [authorization] Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/v2/auth/refreshtoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni informazioni relative alla registrazione dell\'utente
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationInfo: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('registrationInfo', 'username', username)
            const localVarPath = `/v2/auth/registrationinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  ## Per inviare il codice di verifica via SMS, l\'applicativo utilizza il servizio Cognito di AWS.  Il servizio Cognito invia un SMS al numero di telefono specificato nelle informazioni dell\'utente, utilizzando i dati presenti nello user pool di Cognito.  > **[NOTA]** Per cambiare il numero di telefono, l\'utente deve effettuare una `PATCH` su `/user/:userId/change-phone-number`. Questa modifica si riflette sia su Cognito che sul database. 
         * @summary Richiede un codice di verifica via SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/auth/otp/request-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reinvia il codice di conferma all\'utente
         * @param {ResendSignupValidateEmailCodeRequest} resendSignupValidateEmailCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSignupValidateEmailCode: async (resendSignupValidateEmailCodeRequest: ResendSignupValidateEmailCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendSignupValidateEmailCodeRequest' is not null or undefined
            assertParamExists('resendSignupValidateEmailCode', 'resendSignupValidateEmailCodeRequest', resendSignupValidateEmailCodeRequest)
            const localVarPath = `/v2/auth/resendconfirmuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendSignupValidateEmailCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary richiedi la mail per password dimenticata
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('resetPassword', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/v2/auth/resetpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Conferma la reimpostazione della password
         * @param {ResetPasswordConfirmRequest} resetPasswordConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordConfirm: async (resetPasswordConfirmRequest: ResetPasswordConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordConfirmRequest' is not null or undefined
            assertParamExists('resetPasswordConfirm', 'resetPasswordConfirmRequest', resetPasswordConfirmRequest)
            const localVarPath = `/v2/auth/resetpasswordconfirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  ## Il flusso di registrazione prevede i seguenti passaggi:  ### [REGISTRAZIONE]  1. Effettua la registrazione tramite `/auth/signup` o `/auth/loginsocial` (nel caso del social login, la registrazione avviene se l\'utente accede per la prima volta).     > L\'utente viene registrato su Cognito e nel database con lo stato `EMAIL_CONFIRMATION_PENDING`.     > **[NOTA]** Un utente registrato tramite social login non necessita di confermare l\'email e viene registrato con lo stato `PHONE_CONFIRMATION_PENDING` o `ACTIVE` a seconda della presenza o meno del numero di telefono nell\'account social.  ### [VERIFICA EMAIL]  2. Conferma il codice ricevuto per email tramite `/auth/confirmuser`.     > Una volta confermata l\'email, l\'utente passa allo stato `PHONE_CONFIRMATION_PENDING` e riceve una mail di benvenuto.    > Da questo momento l\'utente può effettuare il login e interagire con l\'API.  ### [VERIFICA NUMERO DI TELEFONO]  3. Imposta il numero di telefono tramite `PATCH` su `/user/:userId/change-phone-number`.  4. Richiedi il codice di verifica via SMS tramite `/auth/otp/request-sms`.  5. Verifica il codice di verifica via SMS tramite `/auth/otp/verify-sms`.     > Se l\'utente è un `CLUB_MANAGER`, il backend inserisce automaticamente la richiesta di adesione del club nelle richieste di adesione che devono essere approvate da un `ADMIN`.  ### [PENDING PROFILE INFORMATION]  6. L\'utente può completare il proprio profilo tramite `PATCH` su `/user/:userId`.     > Una volta completate le informazioni, l\'utente passa allo stato `ACTIVE`. 
         * @summary Registra un nuovo utente
         * @param {SignupDto} signupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupDto: SignupDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupDto' is not null or undefined
            assertParamExists('signup', 'signupDto', signupDto)
            const localVarPath = `/v2/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Conferma l\'utente tramite email
         * @param {SignupValidateEmailRequest} signupValidateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupValidateEmail: async (signupValidateEmailRequest: SignupValidateEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupValidateEmailRequest' is not null or undefined
            assertParamExists('signupValidateEmail', 'signupValidateEmailRequest', signupValidateEmailRequest)
            const localVarPath = `/v2/auth/confirmuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupValidateEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifica il codice di verifica via SMS
         * @param {VerifySmsRequest} verifySmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySms: async (verifySmsRequest: VerifySmsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifySmsRequest' is not null or undefined
            assertParamExists('verifySms', 'verifySmsRequest', verifySmsRequest)
            const localVarPath = `/v2/auth/otp/verify-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifySmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cambia la password dell\'utente
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Effettua il login dell\'utente
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Effettua il login tramite social utilizzando l\'idToken fornito dal social stesso
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSocial(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSocial(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.loginSocial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Effettua il logout dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Effettua il refresh dei token identità e accesso mediante il refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [authorization] Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni informazioni relative alla registrazione dell\'utente
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationInfo(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationInfo(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.registrationInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  ## Per inviare il codice di verifica via SMS, l\'applicativo utilizza il servizio Cognito di AWS.  Il servizio Cognito invia un SMS al numero di telefono specificato nelle informazioni dell\'utente, utilizzando i dati presenti nello user pool di Cognito.  > **[NOTA]** Per cambiare il numero di telefono, l\'utente deve effettuare una `PATCH` su `/user/:userId/change-phone-number`. Questa modifica si riflette sia su Cognito che sul database. 
         * @summary Richiede un codice di verifica via SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.requestSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reinvia il codice di conferma all\'utente
         * @param {ResendSignupValidateEmailCodeRequest} resendSignupValidateEmailCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest: ResendSignupValidateEmailCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resendSignupValidateEmailCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary richiedi la mail per password dimenticata
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Conferma la reimpostazione della password
         * @param {ResetPasswordConfirmRequest} resetPasswordConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordConfirm(resetPasswordConfirmRequest: ResetPasswordConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordConfirm(resetPasswordConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPasswordConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  ## Il flusso di registrazione prevede i seguenti passaggi:  ### [REGISTRAZIONE]  1. Effettua la registrazione tramite `/auth/signup` o `/auth/loginsocial` (nel caso del social login, la registrazione avviene se l\'utente accede per la prima volta).     > L\'utente viene registrato su Cognito e nel database con lo stato `EMAIL_CONFIRMATION_PENDING`.     > **[NOTA]** Un utente registrato tramite social login non necessita di confermare l\'email e viene registrato con lo stato `PHONE_CONFIRMATION_PENDING` o `ACTIVE` a seconda della presenza o meno del numero di telefono nell\'account social.  ### [VERIFICA EMAIL]  2. Conferma il codice ricevuto per email tramite `/auth/confirmuser`.     > Una volta confermata l\'email, l\'utente passa allo stato `PHONE_CONFIRMATION_PENDING` e riceve una mail di benvenuto.    > Da questo momento l\'utente può effettuare il login e interagire con l\'API.  ### [VERIFICA NUMERO DI TELEFONO]  3. Imposta il numero di telefono tramite `PATCH` su `/user/:userId/change-phone-number`.  4. Richiedi il codice di verifica via SMS tramite `/auth/otp/request-sms`.  5. Verifica il codice di verifica via SMS tramite `/auth/otp/verify-sms`.     > Se l\'utente è un `CLUB_MANAGER`, il backend inserisce automaticamente la richiesta di adesione del club nelle richieste di adesione che devono essere approvate da un `ADMIN`.  ### [PENDING PROFILE INFORMATION]  6. L\'utente può completare il proprio profilo tramite `PATCH` su `/user/:userId`.     > Una volta completate le informazioni, l\'utente passa allo stato `ACTIVE`. 
         * @summary Registra un nuovo utente
         * @param {SignupDto} signupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupDto: SignupDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Conferma l\'utente tramite email
         * @param {SignupValidateEmailRequest} signupValidateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signupValidateEmail(signupValidateEmailRequest: SignupValidateEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signupValidateEmail(signupValidateEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signupValidateEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifica il codice di verifica via SMS
         * @param {VerifySmsRequest} verifySmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifySms(verifySmsRequest: VerifySmsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifySms(verifySmsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifySms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Cambia la password dell\'utente
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.changePassword(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Effettua il login dell\'utente
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.login(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Effettua il login tramite social utilizzando l\'idToken fornito dal social stesso
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSocial(body: object, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.loginSocial(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Effettua il logout dell\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Effettua il refresh dei token identità e accesso mediante il refresh token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [authorization] Refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseDto> {
            return localVarFp.refreshToken(refreshTokenRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni informazioni relative alla registrazione dell\'utente
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationInfo(username: string, options?: RawAxiosRequestConfig): AxiosPromise<RegistrationInfo> {
            return localVarFp.registrationInfo(username, options).then((request) => request(axios, basePath));
        },
        /**
         *  ## Per inviare il codice di verifica via SMS, l\'applicativo utilizza il servizio Cognito di AWS.  Il servizio Cognito invia un SMS al numero di telefono specificato nelle informazioni dell\'utente, utilizzando i dati presenti nello user pool di Cognito.  > **[NOTA]** Per cambiare il numero di telefono, l\'utente deve effettuare una `PATCH` su `/user/:userId/change-phone-number`. Questa modifica si riflette sia su Cognito che sul database. 
         * @summary Richiede un codice di verifica via SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSms(options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.requestSms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reinvia il codice di conferma all\'utente
         * @param {ResendSignupValidateEmailCodeRequest} resendSignupValidateEmailCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest: ResendSignupValidateEmailCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary richiedi la mail per password dimenticata
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.resetPassword(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Conferma la reimpostazione della password
         * @param {ResetPasswordConfirmRequest} resetPasswordConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordConfirm(resetPasswordConfirmRequest: ResetPasswordConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.resetPasswordConfirm(resetPasswordConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *  ## Il flusso di registrazione prevede i seguenti passaggi:  ### [REGISTRAZIONE]  1. Effettua la registrazione tramite `/auth/signup` o `/auth/loginsocial` (nel caso del social login, la registrazione avviene se l\'utente accede per la prima volta).     > L\'utente viene registrato su Cognito e nel database con lo stato `EMAIL_CONFIRMATION_PENDING`.     > **[NOTA]** Un utente registrato tramite social login non necessita di confermare l\'email e viene registrato con lo stato `PHONE_CONFIRMATION_PENDING` o `ACTIVE` a seconda della presenza o meno del numero di telefono nell\'account social.  ### [VERIFICA EMAIL]  2. Conferma il codice ricevuto per email tramite `/auth/confirmuser`.     > Una volta confermata l\'email, l\'utente passa allo stato `PHONE_CONFIRMATION_PENDING` e riceve una mail di benvenuto.    > Da questo momento l\'utente può effettuare il login e interagire con l\'API.  ### [VERIFICA NUMERO DI TELEFONO]  3. Imposta il numero di telefono tramite `PATCH` su `/user/:userId/change-phone-number`.  4. Richiedi il codice di verifica via SMS tramite `/auth/otp/request-sms`.  5. Verifica il codice di verifica via SMS tramite `/auth/otp/verify-sms`.     > Se l\'utente è un `CLUB_MANAGER`, il backend inserisce automaticamente la richiesta di adesione del club nelle richieste di adesione che devono essere approvate da un `ADMIN`.  ### [PENDING PROFILE INFORMATION]  6. L\'utente può completare il proprio profilo tramite `PATCH` su `/user/:userId`.     > Una volta completate le informazioni, l\'utente passa allo stato `ACTIVE`. 
         * @summary Registra un nuovo utente
         * @param {SignupDto} signupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupDto: SignupDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.signup(signupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Conferma l\'utente tramite email
         * @param {SignupValidateEmailRequest} signupValidateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupValidateEmail(signupValidateEmailRequest: SignupValidateEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.signupValidateEmail(signupValidateEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifica il codice di verifica via SMS
         * @param {VerifySmsRequest} verifySmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySms(verifySmsRequest: VerifySmsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.verifySms(verifySmsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Cambia la password dell\'utente
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).changePassword(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Effettua il login dell\'utente
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Effettua il login tramite social utilizzando l\'idToken fornito dal social stesso
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginSocial(body: object, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginSocial(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Effettua il logout dell\'utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Effettua il refresh dei token identità e accesso mediante il refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {string} [authorization] Refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, authorization?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshToken(refreshTokenRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni informazioni relative alla registrazione dell\'utente
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public registrationInfo(username: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).registrationInfo(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  ## Per inviare il codice di verifica via SMS, l\'applicativo utilizza il servizio Cognito di AWS.  Il servizio Cognito invia un SMS al numero di telefono specificato nelle informazioni dell\'utente, utilizzando i dati presenti nello user pool di Cognito.  > **[NOTA]** Per cambiare il numero di telefono, l\'utente deve effettuare una `PATCH` su `/user/:userId/change-phone-number`. Questa modifica si riflette sia su Cognito che sul database. 
     * @summary Richiede un codice di verifica via SMS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestSms(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).requestSms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reinvia il codice di conferma all\'utente
     * @param {ResendSignupValidateEmailCodeRequest} resendSignupValidateEmailCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest: ResendSignupValidateEmailCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resendSignupValidateEmailCode(resendSignupValidateEmailCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary richiedi la mail per password dimenticata
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPassword(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Conferma la reimpostazione della password
     * @param {ResetPasswordConfirmRequest} resetPasswordConfirmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPasswordConfirm(resetPasswordConfirmRequest: ResetPasswordConfirmRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPasswordConfirm(resetPasswordConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  ## Il flusso di registrazione prevede i seguenti passaggi:  ### [REGISTRAZIONE]  1. Effettua la registrazione tramite `/auth/signup` o `/auth/loginsocial` (nel caso del social login, la registrazione avviene se l\'utente accede per la prima volta).     > L\'utente viene registrato su Cognito e nel database con lo stato `EMAIL_CONFIRMATION_PENDING`.     > **[NOTA]** Un utente registrato tramite social login non necessita di confermare l\'email e viene registrato con lo stato `PHONE_CONFIRMATION_PENDING` o `ACTIVE` a seconda della presenza o meno del numero di telefono nell\'account social.  ### [VERIFICA EMAIL]  2. Conferma il codice ricevuto per email tramite `/auth/confirmuser`.     > Una volta confermata l\'email, l\'utente passa allo stato `PHONE_CONFIRMATION_PENDING` e riceve una mail di benvenuto.    > Da questo momento l\'utente può effettuare il login e interagire con l\'API.  ### [VERIFICA NUMERO DI TELEFONO]  3. Imposta il numero di telefono tramite `PATCH` su `/user/:userId/change-phone-number`.  4. Richiedi il codice di verifica via SMS tramite `/auth/otp/request-sms`.  5. Verifica il codice di verifica via SMS tramite `/auth/otp/verify-sms`.     > Se l\'utente è un `CLUB_MANAGER`, il backend inserisce automaticamente la richiesta di adesione del club nelle richieste di adesione che devono essere approvate da un `ADMIN`.  ### [PENDING PROFILE INFORMATION]  6. L\'utente può completare il proprio profilo tramite `PATCH` su `/user/:userId`.     > Una volta completate le informazioni, l\'utente passa allo stato `ACTIVE`. 
     * @summary Registra un nuovo utente
     * @param {SignupDto} signupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signup(signupDto: SignupDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signup(signupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Conferma l\'utente tramite email
     * @param {SignupValidateEmailRequest} signupValidateEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signupValidateEmail(signupValidateEmailRequest: SignupValidateEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signupValidateEmail(signupValidateEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifica il codice di verifica via SMS
     * @param {VerifySmsRequest} verifySmsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifySms(verifySmsRequest: VerifySmsRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifySms(verifySmsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingApi - axios parameter creator
 * @export
 */
export const BookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ritorna una response con un message: \"OK\" e codice 201 se va tutto bene, altrimenti una BadRequest con il messaggio di errore corrispondente
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canbooking: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('canbooking', 'clubId', clubId)
            const localVarPath = `/v2/booking/canbooking/{clubId}`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ritorna 3 flag: - annullabile: se annullabile è solo a livello di tempo - split payment possibile: se è splittabile è legato al tempo (sono ancora nel periodo dello split payment) - che ci siano o meno pagamenti fatti: importo pagato minore del totale, utente che lo richiede non ha ancora pagato
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getStatus', 'bookingId', bookingId)
            const localVarPath = `/v2/booking/{bookingId}/status`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingApi - functional programming interface
 * @export
 */
export const BookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ritorna una response con un message: \"OK\" e codice 201 se va tutto bene, altrimenti una BadRequest con il messaggio di errore corrispondente
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canbooking(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Canbooking201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canbooking(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.canbooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ritorna 3 flag: - annullabile: se annullabile è solo a livello di tempo - split payment possibile: se è splittabile è legato al tempo (sono ancora nel periodo dello split payment) - che ci siano o meno pagamenti fatti: importo pagato minore del totale, utente che lo richiede non ha ancora pagato
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.getStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingApi - factory interface
 * @export
 */
export const BookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingApiFp(configuration)
    return {
        /**
         * 
         * @summary Ritorna una response con un message: \"OK\" e codice 201 se va tutto bene, altrimenti una BadRequest con il messaggio di errore corrispondente
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canbooking(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<Canbooking201Response> {
            return localVarFp.canbooking(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ritorna 3 flag: - annullabile: se annullabile è solo a livello di tempo - split payment possibile: se è splittabile è legato al tempo (sono ancora nel periodo dello split payment) - che ci siano o meno pagamenti fatti: importo pagato minore del totale, utente che lo richiede non ha ancora pagato
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(bookingId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetStatus200Response> {
            return localVarFp.getStatus(bookingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingApi - object-oriented interface
 * @export
 * @class BookingApi
 * @extends {BaseAPI}
 */
export class BookingApi extends BaseAPI {
    /**
     * 
     * @summary Ritorna una response con un message: \"OK\" e codice 201 se va tutto bene, altrimenti una BadRequest con il messaggio di errore corrispondente
     * @param {string} clubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public canbooking(clubId: string, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).canbooking(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ritorna 3 flag: - annullabile: se annullabile è solo a livello di tempo - split payment possibile: se è splittabile è legato al tempo (sono ancora nel periodo dello split payment) - che ci siano o meno pagamenti fatti: importo pagato minore del totale, utente che lo richiede non ha ancora pagato
     * @param {string} bookingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public getStatus(bookingId: string, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).getStatus(bookingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MembershipApi - axios parameter creator
 * @export
 */
export const MembershipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Autorizzazioni: PLAYER, CLUB_MANAGER, ADMIN
         * @summary Crea una nuova membership
         * @param {CreateMembershipDto} createMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createMembershipDto: CreateMembershipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMembershipDto' is not null or undefined
            assertParamExists('create', 'createMembershipDto', createMembershipDto)
            const localVarPath = `/v2/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMembershipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni tutte le membership
         * @param {string} [clubId] ID del club
         * @param {string} [userId] ID utente
         * @param {FindAllStatusEnum} [status] Status della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (clubId?: string, userId?: string, status?: FindAllStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clubId !== undefined) {
                localVarQueryParameter['clubId'] = clubId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni una membership per ID
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/v2/membership/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Segna il welcome kit come consegnato
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWelcomeKitDelivered: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markWelcomeKitDelivered', 'id', id)
            const localVarPath = `/v2/membership/{id}/deliverwelcomekit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: anyone, PLAYER can only purchase with payment method CARD (online payment)
         * @summary Acquista una membership
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseMembership: async (purchaseMembershipDto: PurchaseMembershipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseMembershipDto' is not null or undefined
            assertParamExists('purchaseMembership', 'purchaseMembershipDto', purchaseMembershipDto)
            const localVarPath = `/v2/membership/purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseMembershipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Cancella una membership per ID (logical delete, sets the status to CANCELLED)
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/v2/membership/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Aggiorna una membership per ID
         * @param {string} id ID della membership
         * @param {UpdateMembershipDto} updateMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateMembershipDto: UpdateMembershipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateMembershipDto' is not null or undefined
            assertParamExists('update', 'updateMembershipDto', updateMembershipDto)
            const localVarPath = `/v2/membership/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMembershipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRenewMembership: async (purchaseMembershipDto: PurchaseMembershipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseMembershipDto' is not null or undefined
            assertParamExists('updateRenewMembership', 'purchaseMembershipDto', purchaseMembershipDto)
            const localVarPath = `/v2/membership/updaterenew`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseMembershipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembershipApi - functional programming interface
 * @export
 */
export const MembershipApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembershipApiAxiosParamCreator(configuration)
    return {
        /**
         * Autorizzazioni: PLAYER, CLUB_MANAGER, ADMIN
         * @summary Crea una nuova membership
         * @param {CreateMembershipDto} createMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createMembershipDto: CreateMembershipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createMembershipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni tutte le membership
         * @param {string} [clubId] ID del club
         * @param {string} [userId] ID utente
         * @param {FindAllStatusEnum} [status] Status della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(clubId?: string, userId?: string, status?: FindAllStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Membership>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(clubId, userId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni una membership per ID
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.findOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Segna il welcome kit come consegnato
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markWelcomeKitDelivered(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markWelcomeKitDelivered(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.markWelcomeKitDelivered']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: anyone, PLAYER can only purchase with payment method CARD (online payment)
         * @summary Acquista una membership
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseMembership(purchaseMembershipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.purchaseMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Cancella una membership per ID (logical delete, sets the status to CANCELLED)
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Aggiorna una membership per ID
         * @param {string} id ID della membership
         * @param {UpdateMembershipDto} updateMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateMembershipDto: UpdateMembershipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateMembershipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRenewMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRenewMembership(purchaseMembershipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.updateRenewMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MembershipApi - factory interface
 * @export
 */
export const MembershipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembershipApiFp(configuration)
    return {
        /**
         * Autorizzazioni: PLAYER, CLUB_MANAGER, ADMIN
         * @summary Crea una nuova membership
         * @param {CreateMembershipDto} createMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createMembershipDto: CreateMembershipDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.create(createMembershipDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni tutte le membership
         * @param {string} [clubId] ID del club
         * @param {string} [userId] ID utente
         * @param {FindAllStatusEnum} [status] Status della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(clubId?: string, userId?: string, status?: FindAllStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Membership>> {
            return localVarFp.findAll(clubId, userId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Ottieni una membership per ID
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Segna il welcome kit come consegnato
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWelcomeKitDelivered(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markWelcomeKitDelivered(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: anyone, PLAYER can only purchase with payment method CARD (online payment)
         * @summary Acquista una membership
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.purchaseMembership(purchaseMembershipDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Cancella una membership per ID (logical delete, sets the status to CANCELLED)
         * @param {string} id ID della membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
         * @summary Aggiorna una membership per ID
         * @param {string} id ID della membership
         * @param {UpdateMembershipDto} updateMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateMembershipDto: UpdateMembershipDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(id, updateMembershipDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PurchaseMembershipDto} purchaseMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRenewMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRenewMembership(purchaseMembershipDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembershipApi - object-oriented interface
 * @export
 * @class MembershipApi
 * @extends {BaseAPI}
 */
export class MembershipApi extends BaseAPI {
    /**
     * Autorizzazioni: PLAYER, CLUB_MANAGER, ADMIN
     * @summary Crea una nuova membership
     * @param {CreateMembershipDto} createMembershipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public create(createMembershipDto: CreateMembershipDto, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).create(createMembershipDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
     * @summary Ottieni tutte le membership
     * @param {string} [clubId] ID del club
     * @param {string} [userId] ID utente
     * @param {FindAllStatusEnum} [status] Status della membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public findAll(clubId?: string, userId?: string, status?: FindAllStatusEnum, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).findAll(clubId, userId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
     * @summary Ottieni una membership per ID
     * @param {string} id ID della membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public findOne(id: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
     * @summary Segna il welcome kit come consegnato
     * @param {string} id ID della membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public markWelcomeKitDelivered(id: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).markWelcomeKitDelivered(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: anyone, PLAYER can only purchase with payment method CARD (online payment)
     * @summary Acquista una membership
     * @param {PurchaseMembershipDto} purchaseMembershipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public purchaseMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).purchaseMembership(purchaseMembershipDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: PLAYER (only own membership), CLUB_MANAGER (only own club memberships), ADMIN
     * @summary Cancella una membership per ID (logical delete, sets the status to CANCELLED)
     * @param {string} id ID della membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public remove(id: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Autorizzazioni: CLUB_MANAGER (only own club memberships), ADMIN
     * @summary Aggiorna una membership per ID
     * @param {string} id ID della membership
     * @param {UpdateMembershipDto} updateMembershipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public update(id: string, updateMembershipDto: UpdateMembershipDto, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).update(id, updateMembershipDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PurchaseMembershipDto} purchaseMembershipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public updateRenewMembership(purchaseMembershipDto: PurchaseMembershipDto, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).updateRenewMembership(purchaseMembershipDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FindAllStatusEnum = {
    Active: 'active',
    Suspended: 'suspended',
    PendingPayment: 'pending_payment'
} as const;
export type FindAllStatusEnum = typeof FindAllStatusEnum[keyof typeof FindAllStatusEnum];


/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ritorna true se c\'è almeno un pagamento in corso per la prenotazione da parte dell\'utente
         * @param {string} bookingId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsBookingPaymentForUser: async (bookingId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('existsBookingPaymentForUser', 'bookingId', bookingId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('existsBookingPaymentForUser', 'userId', userId)
            const localVarPath = `/v2/payment/booking/{bookingId}/user/{userId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ritorna elenco dei pagamenti per l\'utente  con un determinato stato. Usare ALL per averli indistintamente tutti
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsPaymentForUser: async (status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('existsPaymentForUser', 'status', status)
            const localVarPath = `/v2/payment/paymentuser/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le prenotazioni
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBookingPayments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/payment/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMembershipPayments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/payment/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni un pagamento prenotazione esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingPayment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBookingPayment', 'id', id)
            const localVarPath = `/v2/payment/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni un pagamento membership esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipPayment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMembershipPayment', 'id', id)
            const localVarPath = `/v2/payment/membership/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Crea o modifica la carta associata all\'utente effettuando un primo pagamento con importo 0
         * @param {SaveCardRequest} saveCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiCreateContract: async (saveCardRequest: SaveCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveCardRequest' is not null or undefined
            assertParamExists('nexiCreateContract', 'saveCardRequest', saveCardRequest)
            const localVarPath = `/v2/payment/nexicard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rimuovi la carta associata all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiDeleteContract: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/payment/nexicard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni la carta associata all\'utente, se esiste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiGetContract: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/payment/nexicard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Esegue il pagamento di una prenotazione tramite contratto Nexi
         * @param {RecurringPaymentRequest} recurringPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiRecurringPayment: async (recurringPaymentRequest: RecurringPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recurringPaymentRequest' is not null or undefined
            assertParamExists('nexiRecurringPayment', 'recurringPaymentRequest', recurringPaymentRequest)
            const localVarPath = `/v2/payment/booking/paynow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recurringPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gestisce il callback dei pagamenti da provider esterni
         * @param {PaymentCallbackDto} paymentCallbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCallback: async (paymentCallbackDto: PaymentCallbackDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentCallbackDto' is not null or undefined
            assertParamExists('paymentCallback', 'paymentCallbackDto', paymentCallbackDto)
            const localVarPath = `/v2/payment/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentCallbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per prenotazione
         * @param {BookingPaymentRequest} bookingPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBookingPayment: async (bookingPaymentRequest: BookingPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingPaymentRequest' is not null or undefined
            assertParamExists('postBookingPayment', 'bookingPaymentRequest', bookingPaymentRequest)
            const localVarPath = `/v2/payment/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per membership
         * @param {MembershipPaymentRequest} membershipPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMembershipPayment: async (membershipPaymentRequest: MembershipPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipPaymentRequest' is not null or undefined
            assertParamExists('postMembershipPayment', 'membershipPaymentRequest', membershipPaymentRequest)
            const localVarPath = `/v2/payment/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ritorna true se c\'è almeno un pagamento in corso per la prenotazione da parte dell\'utente
         * @param {string} bookingId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsBookingPaymentForUser(bookingId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsBookingPaymentForUser(bookingId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.existsBookingPaymentForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ritorna elenco dei pagamenti per l\'utente  con un determinato stato. Usare ALL per averli indistintamente tutti
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsPaymentForUser(status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsPaymentForUser(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.existsPaymentForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le prenotazioni
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBookingPayments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBookingPayments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getAllBookingPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMembershipPayments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMembershipPayments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getAllMembershipPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPayments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPayments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getAllPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni un pagamento prenotazione esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingPayment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getBookingPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni un pagamento membership esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembershipPayment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembershipPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.getMembershipPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Crea o modifica la carta associata all\'utente effettuando un primo pagamento con importo 0
         * @param {SaveCardRequest} saveCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nexiCreateContract(saveCardRequest: SaveCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nexiCreateContract(saveCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.nexiCreateContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rimuovi la carta associata all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nexiDeleteContract(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nexiDeleteContract(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.nexiDeleteContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni la carta associata all\'utente, se esiste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nexiGetContract(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nexiGetContract(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.nexiGetContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Esegue il pagamento di una prenotazione tramite contratto Nexi
         * @param {RecurringPaymentRequest} recurringPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nexiRecurringPayment(recurringPaymentRequest: RecurringPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nexiRecurringPayment(recurringPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.nexiRecurringPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gestisce il callback dei pagamenti da provider esterni
         * @param {PaymentCallbackDto} paymentCallbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentCallback(paymentCallbackDto: PaymentCallbackDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentCallback(paymentCallbackDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.paymentCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per prenotazione
         * @param {BookingPaymentRequest} bookingPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBookingPayment(bookingPaymentRequest: BookingPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBookingPayment(bookingPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.postBookingPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per membership
         * @param {MembershipPaymentRequest} membershipPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMembershipPayment(membershipPaymentRequest: MembershipPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMembershipPayment(membershipPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.postMembershipPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary Ritorna true se c\'è almeno un pagamento in corso per la prenotazione da parte dell\'utente
         * @param {string} bookingId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsBookingPaymentForUser(bookingId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.existsBookingPaymentForUser(bookingId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ritorna elenco dei pagamenti per l\'utente  con un determinato stato. Usare ALL per averli indistintamente tutti
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsPaymentForUser(status: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.existsPaymentForUser(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le prenotazioni
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBookingPayments(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAllBookingPayments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti per le membership
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMembershipPayments(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAllMembershipPayments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni tutti i pagamenti
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayments(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAllPayments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni un pagamento prenotazione esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingPayment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getBookingPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni un pagamento membership esistente
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipPayment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMembershipPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea o modifica la carta associata all\'utente effettuando un primo pagamento con importo 0
         * @param {SaveCardRequest} saveCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiCreateContract(saveCardRequest: SaveCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.nexiCreateContract(saveCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rimuovi la carta associata all\'utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiDeleteContract(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.nexiDeleteContract(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni la carta associata all\'utente, se esiste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiGetContract(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.nexiGetContract(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Esegue il pagamento di una prenotazione tramite contratto Nexi
         * @param {RecurringPaymentRequest} recurringPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nexiRecurringPayment(recurringPaymentRequest: RecurringPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.nexiRecurringPayment(recurringPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gestisce il callback dei pagamenti da provider esterni
         * @param {PaymentCallbackDto} paymentCallbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCallback(paymentCallbackDto: PaymentCallbackDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentCallback(paymentCallbackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per prenotazione
         * @param {BookingPaymentRequest} bookingPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBookingPayment(bookingPaymentRequest: BookingPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postBookingPayment(bookingPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedula un nuovo pagamento per membership
         * @param {MembershipPaymentRequest} membershipPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMembershipPayment(membershipPaymentRequest: MembershipPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMembershipPayment(membershipPaymentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
    /**
     * 
     * @summary Ritorna true se c\'è almeno un pagamento in corso per la prenotazione da parte dell\'utente
     * @param {string} bookingId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public existsBookingPaymentForUser(bookingId: string, userId: string, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).existsBookingPaymentForUser(bookingId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ritorna elenco dei pagamenti per l\'utente  con un determinato stato. Usare ALL per averli indistintamente tutti
     * @param {string} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public existsPaymentForUser(status: string, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).existsPaymentForUser(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni tutti i pagamenti per le prenotazioni
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getAllBookingPayments(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getAllBookingPayments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni tutti i pagamenti per le membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getAllMembershipPayments(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getAllMembershipPayments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni tutti i pagamenti
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getAllPayments(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getAllPayments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni un pagamento prenotazione esistente
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getBookingPayment(id: string, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getBookingPayment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni un pagamento membership esistente
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public getMembershipPayment(id: string, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).getMembershipPayment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea o modifica la carta associata all\'utente effettuando un primo pagamento con importo 0
     * @param {SaveCardRequest} saveCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public nexiCreateContract(saveCardRequest: SaveCardRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).nexiCreateContract(saveCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rimuovi la carta associata all\'utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public nexiDeleteContract(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).nexiDeleteContract(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni la carta associata all\'utente, se esiste
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public nexiGetContract(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).nexiGetContract(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Esegue il pagamento di una prenotazione tramite contratto Nexi
     * @param {RecurringPaymentRequest} recurringPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public nexiRecurringPayment(recurringPaymentRequest: RecurringPaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).nexiRecurringPayment(recurringPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gestisce il callback dei pagamenti da provider esterni
     * @param {PaymentCallbackDto} paymentCallbackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public paymentCallback(paymentCallbackDto: PaymentCallbackDto, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).paymentCallback(paymentCallbackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedula un nuovo pagamento per prenotazione
     * @param {BookingPaymentRequest} bookingPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public postBookingPayment(bookingPaymentRequest: BookingPaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).postBookingPayment(bookingPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedula un nuovo pagamento per membership
     * @param {MembershipPaymentRequest} membershipPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public postMembershipPayment(membershipPaymentRequest: MembershipPaymentRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).postMembershipPayment(membershipPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingApi.ping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public ping(options?: RawAxiosRequestConfig) {
        return PingApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ottieni la config di sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigSystemPublic: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/settings/wesmash_system`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ottieni la config di sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigSystemPublic(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigSystemPublic(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getConfigSystemPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Ottieni la config di sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigSystemPublic(options?: RawAxiosRequestConfig): AxiosPromise<Settings> {
            return localVarFp.getConfigSystemPublic(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * 
     * @summary Ottieni la config di sistema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getConfigSystemPublic(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getConfigSystemPublic(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyApi - axios parameter creator
 * @export
 */
export const SurveyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Carica le risposte al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswers: async (surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyVersion' is not null or undefined
            assertParamExists('createAnswers', 'surveyVersion', surveyVersion)
            // verify required parameter 'surveyAnswersRequestModel' is not null or undefined
            assertParamExists('createAnswers', 'surveyAnswersRequestModel', surveyAnswersRequestModel)
            const localVarPath = `/v2/survey/{surveyVersion}/answers`
                .replace(`{${"surveyVersion"}}`, encodeURIComponent(String(surveyVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyAnswersRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancella le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswers: async (surveyVersion: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyVersion' is not null or undefined
            assertParamExists('deleteAnswers', 'surveyVersion', surveyVersion)
            const localVarPath = `/v2/survey/{surveyVersion}/answers`
                .replace(`{${"surveyVersion"}}`, encodeURIComponent(String(surveyVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni il survey con la versione più recente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSurvey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAnswers: async (surveyVersion: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyVersion' is not null or undefined
            assertParamExists('readAnswers', 'surveyVersion', surveyVersion)
            const localVarPath = `/v2/survey/{surveyVersion}/answers`
                .replace(`{${"surveyVersion"}}`, encodeURIComponent(String(surveyVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni le risposte date da uno specifico utente al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserAnswers: async (surveyVersion: number, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyVersion' is not null or undefined
            assertParamExists('readUserAnswers', 'surveyVersion', surveyVersion)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readUserAnswers', 'userId', userId)
            const localVarPath = `/v2/survey/{surveyVersion}/answers/{userId}`
                .replace(`{${"surveyVersion"}}`, encodeURIComponent(String(surveyVersion)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggiorna le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswers: async (surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyVersion' is not null or undefined
            assertParamExists('updateAnswers', 'surveyVersion', surveyVersion)
            // verify required parameter 'surveyAnswersRequestModel' is not null or undefined
            assertParamExists('updateAnswers', 'surveyAnswersRequestModel', surveyAnswersRequestModel)
            const localVarPath = `/v2/survey/{surveyVersion}/answers`
                .replace(`{${"surveyVersion"}}`, encodeURIComponent(String(surveyVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyAnswersRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyApi - functional programming interface
 * @export
 */
export const SurveyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Carica le risposte al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnswers(surveyVersion, surveyAnswersRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.createAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancella le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnswers(surveyVersion: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnswers(surveyVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.deleteAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni il survey con la versione più recente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestSurvey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestSurvey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.getLatestSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAnswers(surveyVersion: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAnswers(surveyVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.readAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni le risposte date da uno specifico utente al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUserAnswers(surveyVersion: number, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUserAnswers(surveyVersion, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.readUserAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggiorna le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnswers(surveyVersion, surveyAnswersRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.updateAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyApi - factory interface
 * @export
 */
export const SurveyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyApiFp(configuration)
    return {
        /**
         * 
         * @summary Carica le risposte al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAnswers(surveyVersion, surveyAnswersRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancella le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswers(surveyVersion: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAnswers(surveyVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni il survey con la versione più recente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSurvey(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getLatestSurvey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAnswers(surveyVersion: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.readAnswers(surveyVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni le risposte date da uno specifico utente al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {string} userId ID dell\&#39;utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserAnswers(surveyVersion: number, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.readUserAnswers(surveyVersion, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggiorna le risposte date al survey con la versione <surveyVersion>
         * @param {number} surveyVersion Versione del survey
         * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAnswers(surveyVersion, surveyAnswersRequestModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
export class SurveyApi extends BaseAPI {
    /**
     * 
     * @summary Carica le risposte al survey con la versione <surveyVersion>
     * @param {number} surveyVersion Versione del survey
     * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public createAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).createAnswers(surveyVersion, surveyAnswersRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancella le risposte date al survey con la versione <surveyVersion>
     * @param {number} surveyVersion Versione del survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public deleteAnswers(surveyVersion: number, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).deleteAnswers(surveyVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni il survey con la versione più recente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getLatestSurvey(options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getLatestSurvey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni le risposte date al survey con la versione <surveyVersion>
     * @param {number} surveyVersion Versione del survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public readAnswers(surveyVersion: number, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).readAnswers(surveyVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni le risposte date da uno specifico utente al survey con la versione <surveyVersion>
     * @param {number} surveyVersion Versione del survey
     * @param {string} userId ID dell\&#39;utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public readUserAnswers(surveyVersion: number, userId: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).readUserAnswers(surveyVersion, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggiorna le risposte date al survey con la versione <surveyVersion>
     * @param {number} surveyVersion Versione del survey
     * @param {SurveyAnswersRequestModel} surveyAnswersRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public updateAnswers(surveyVersion: number, surveyAnswersRequestModel: SurveyAnswersRequestModel, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).updateAnswers(surveyVersion, surveyAnswersRequestModel, options).then((request) => request(this.axios, this.basePath));
    }
}



